import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { LockerPersonInsertRequest } from "./LockerPersonInsertRequest";
import { LockerPersonUpdateRequest } from "./LockerPersonUpdateRequest";
import { LockerPersonUnassignRequest } from "./LockerPersonUnassignRequest";

@Injectable()
export class DataService_StudentLocker {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	LockerSelectByPerson(PersonID) {
		var postResult$ = new Subject();
		var url = "Locker/LockerSelectByPerson?PersonID=" + PersonID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LockerSelectList(SchoolID) {
		var postResult$ = new Subject();
		var url = "Locker/LockerSelectList?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LockerPersonInsert(parms: LockerPersonInsertRequest) {
		var postResult$ = new Subject();
		var url = "Locker/LockerPersonInsert";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	StudentHasLocker(PersonID) {
		var postResult$ = new Subject();
		var url = "Locker/StudentHasLocker?PersonID=" + PersonID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LockerPersonUpdate(parms: LockerPersonUpdateRequest) {
		var postResult$ = new Subject();
		var url = "Locker/LockerPersonUpdate";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LockerPersonUnassign(parms: LockerPersonUnassignRequest) {
		var postResult$ = new Subject();
		var url = "Locker/LockerPersonUnassign";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
